import { IconSvg } from './IconSvg'
import type { IconProps } from './IconSvg'

/** pushpin, pinned note. Decorative line icon; always pair with a visible text label. */
export function PinIcon({ size, className }: IconProps) {
  return (
    <IconSvg size={size} className={className}>
      <path d="M9 4.5h6" />
      <path d="M9.8 4.5L9.3 10l-2.8 3.2V15.5h11v-2.3L14.7 10l-.5-5.5" />
      <path d="M12 15.5V21" />
    </IconSvg>
  )
}
